import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showCompare: '=',
        sites: '=',
        classifiers: '=',
        filter: '=',
        errors: '=',
        comparisonGroups: '='
    },
    template: `
        <div class="table-filters">
            <h2 ng-if="vm.showCompare===true">{{ 'filter.Compare report' | translate }}</h2>
            <form class="form form-filter" ng-if="vm.showCompare===true" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <form-row error="vm.errors.departmentIds" ng-if="vm.errors.departmentIds">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <form-row error="vm.errors.siteIds" ng-if="vm.errors.siteIds">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                ng-click="vm.updateEmployees()"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <label class="label">{{ 'survey.Previous survey group' | translate }}</label>
                      <div class="items">
                        <select class="form-control"
                                ng-model="vm.filter.comparisonGuid"
                                ng-options="group.guid as group.activeI18n.name
                                            for group in vm.comparisonGroups
                                            track by group.guid">
                          <option value="">-</option>
                        </select>
                      </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                   <li><input type="submit" class="btn main" value="{{ 'filter.Compare' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, lodash, CLASSIFIER_ENUM, SiteService, Filter2Service, ROLE_CODE_ENUM,
        UserResource) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.SiteService = SiteService;
        this.FilterService = Filter2Service;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.UserResource = UserResource;
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);

        this.initMultiFilter();

        this.filterOverview = {
            labels: {
                'siteIds[]': this.$translate.instant('filter.Site'),
                'departmentIds[]': this.$translate.instant('filter.Department')
            },
            values: {}
        };
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);

        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };

        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);

        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.filter.departmentIds = this.FilterService.departmentSelect.models
        .filter((department) => department.id !== null)
        .map((department) => department.id);

        this.$scope.$parent.vm.compareReport();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/compare/report/index.js